module.exports = __webpack_public_path__ + "media/share.08ec1024.svg";